import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { combineReducers } from 'redux';
import {
  authReducer,
  contentReducer,
  commonReducer,
  corporateReducer,
  accountOpeningReducer,
} from './slices';

const persistConfig = {
  key: 'corporate-oao-root',
  storage,
  whitelist: ['content'],
};

const appReducer = combineReducers({
  content: contentReducer,
  auth: authReducer,
  common: commonReducer,
  corporate: corporateReducer,
  accountOpening: accountOpeningReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') {
    return appReducer(
      {
        content: state?.content, // preserve content
      },
      action
    );
  }

  return appReducer(state, action);
};


const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;
